module.exports = __webpack_public_path__ + "img/se.b039bdb8.svg";